import { defineEntity, custom, lifecycle } from './_helpers.js';

export default defineEntity('user', {
    registered:               lifecycle({ scope: 'identity' }),
    activated:                custom({ scope: 'identity' }),
    deactivated:              custom({ scope: 'identity' }),
    invited:                  custom({ scope: 'identity' }),
    invitationAccepted:       custom({ scope: 'identity' }),
    profileUpdated:           custom({ scope: 'identity' }),
    emailChanged:             custom({ scope: 'security' }),
    passwordChanged:          custom({ scope: 'security' }),
    passwordResetRequested:   custom({ scope: 'security' }),
    passwordResetCompleted:   custom({ scope: 'security' }),
    mfaEnabled:               custom({ scope: 'security' }),
    mfaDisabled:              custom({ scope: 'security' }),
    mfaChallengeFailed:       custom({ scope: 'security' }),
    'membership.changed':     custom({ scope: 'state' }),
});
